import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class MembersAdminService extends BaseService<any> {
  constructor() {
    super(`members`);
  }

  // Станция, привязанная к сотруднику (оператору приёмки/выдачи). data — станция или null.
  getStation = (memberID: any) =>
    appAxios.get(`${this.pathWithOrg()}/${memberID}/stations`);

  // Установка/снятие станции сотрудника. payload: { stationID: string | null }
  setStation = (memberID: any, stationID: string | null) =>
    appAxios.put(`${this.pathWithOrg()}/${memberID}/stations`, { stationID });
}

export default new MembersAdminService();
